
import * as React from 'react';
import { IUserInfo } from '../../../../ts/models/IUserInfo';
import { DetailsTooltipStyles } from '../../CardView/DetailsTooltipStyles';
import { SpacesSiteUrls } from '../../SpacesSiteUrls';

export interface UserProps {
  label: string;
  user: IUserInfo;
  urls: SpacesSiteUrls;
}

export function User(props: UserProps) {
  return (
    <div className={DetailsTooltipStyles.MetadataSection}>
      <span className={DetailsTooltipStyles.MetadataTitle}>{ props.label }</span>
      <span className={DetailsTooltipStyles.MetadataValue}>
        <a href={ props.urls.userContentUrl(props.user.username, props.user.domainName) }>{ props.user.displayName }</a>
      </span>
    </div>
  );
}
